import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react'
import { IPublicClientApplication } from '@azure/msal-browser';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { persistQueryClient } from 'react-query/persistQueryClient-experimental'
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental'
 

import ProvideAppContext from './AppContext';
import ErrorMessage from './ErrorMessage';
import NavBar from './NavBar';
import HomeAuthenticated from './HomeAuthenticated';

import Calendar from './Calendar';
import Dashboard from './Dashboard';
import CalendarPublic from './CalendarPublic';
import SendAvailability from './SendAvailability';
import StudentPrivateRoute from './StudentPrivateRoute';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import HomeMarketing from './HomeMarketing';
import React from 'react';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBpFcVvXxrwmlubLz2uU50iZTe1Tfdotdg",
  authDomain: "asod-scheduling.firebaseapp.com",
  databaseURL: "https://asod-scheduling-default-rtdb.firebaseio.com",
  projectId: "asod-scheduling",
  storageBucket: "asod-scheduling.appspot.com",
  messagingSenderId: "857071976484",
  appId: "1:857071976484:web:4919e069acb498dee058b1",
  measurementId: "G-6GEW0Q2MXK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const GoogleAnalytics = getAnalytics(app);

type AppProps = {
  pca: IPublicClientApplication
};

const defaultQueryFn = async ({ queryKey }: {queryKey: any[]}) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${queryKey[0]}`)
    .then(response => response.json());
};

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // @ts-ignore
      queryFn: defaultQueryFn,
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
})

const localStoragePersistor = createWebStoragePersistor({storage: window.localStorage})

persistQueryClient({
  queryClient,
  persistor: localStoragePersistor,
})

export default function App({ pca }: AppProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <MsalProvider instance={pca}>
        <Router>
          <ProvideAppContext>
            <Switch>
              <Route path="/" component={varyHomePageBasedOnAuthentication} />
            </Switch>
          </ProvideAppContext>
        </Router>
      </MsalProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

function varyHomePageBasedOnAuthentication(){
  return(
    <React.Fragment>
      <UnauthenticatedTemplate>
        <MarketingLayout></MarketingLayout>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <ApplicationLayout></ApplicationLayout>
      </AuthenticatedTemplate>
    </React.Fragment>
  )
}


function MarketingLayout() {
  return (
    <div className="tw-bg-white dark:tw-bg-slate-900">
      <Switch>
        <Route exact path="/"
          render={(props) =>
            <HomeMarketing {...props} />
          } />
        
        <Route exact path="/:onyen"
          render={(props) =>
            <CalendarPublic {...props} />
          } />
      </Switch>
    </div>
  );
}

function ApplicationLayout() {
  return (
    <div className="tw-bg-white dark:tw-bg-slate-900">
      <NavBar />
      <ErrorMessage />
      <Switch>
        <Route exact path="/"
          render={(props) =>
            <HomeAuthenticated {...props} />
            
          } />
        <StudentPrivateRoute exact path="/calendar" component={Calendar}/>
        <StudentPrivateRoute exact path="/send-availability" component={SendAvailability}/>
        <StudentPrivateRoute exact path="/dashboard" component={Dashboard}/>
        <Route exact path="/calendar-public"
          render={(props) =>
            <CalendarPublic {...props} />
          } />
        <Route exact path="/:onyen"
          render={(props) =>
            <CalendarPublic {...props} />
          } />
      </Switch>
    </div>
  )
}